import Icon from "@Atom/Icon";
import Styles from "./styles.module.scss";
import { useCallback, useEffect, useState } from "react";
import { getDetailCandidatePerJobPostingClient } from "@Services/home";
import { Skeleton } from "@mui/material";
import { fileBaseUrl } from "@Config/api";
import Images from "@Theme/Images";
import moment from "moment";

export default function DetailCandidateModal({
  data = null,
  handleClose = () => {},
  setSuccess,
}) {
  const [loading, setLoading] = useState(false);
  const [candidate, setCandidate] = useState(null);

  const fecthDataCandidate = useCallback(async () => {
    try {
      setLoading(true);

      const { response } = await getDetailCandidatePerJobPostingClient(
        data?.candidateAccountID,
        data?.appliedJobID
      );

      setLoading(false);
      setCandidate(response);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      fecthDataCandidate();
    }
  }, [data, fecthDataCandidate]);

  return (
    <div className={Styles.container}>
      <div className={Styles.header}>
        <span className={Styles.title}>Detail Kandidat</span>
        <Icon
          icon={"cross"}
          size={24}
          color={"#0A0A0A"}
          className={Styles.cross}
          onClick={handleClose}
        />
      </div>

      <div className={Styles.content}>
        <div className={Styles.box}>
          <div className={Styles.imagesProfile}>
            {loading ? (
              <Skeleton variant="circular" width={120} height={120} />
            ) : (
              <img
                src={
                  candidate?.profilePic
                    ? fileBaseUrl + candidate?.profilePic
                    : Images.AVA_DEFAULT
                }
                alt=""
              />
            )}
          </div>

          <div className={Styles.descProfile}>
            <span className={Styles.H1}>
              {loading ? <Skeleton height={20} /> : candidate?.name || "-"}
            </span>

            <div className={Styles.list}>
              <div>
                <span className={Styles.spanLeft}>
                  {loading ? <Skeleton /> : "NIK"}
                </span>
                <span className={Styles.spanRight}>
                  {loading ? <Skeleton /> : `: ${candidate?.idNumber || "-"}`}
                </span>
              </div>

              <div>
                <span className={Styles.spanLeft}>
                  {loading ? <Skeleton /> : "Tanggal lahir"}
                </span>
                <span className={Styles.spanRight}>
                  {loading ? (
                    <Skeleton />
                  ) : (
                    `: ${
                      candidate?.dateOfBirth
                        ? moment(new Date(candidate?.dateOfBirth)).format(
                            "DD MMMM YYYY"
                          )
                        : "-"
                    }`
                  )}
                </span>
              </div>

              <div>
                <span className={Styles.spanLeft}>
                  {loading ? <Skeleton /> : "Alamat Domisili"}
                </span>
                <span className={Styles.spanRight}>
                  {loading ? <Skeleton /> : `: ${candidate?.address || "-"}`}
                </span>
              </div>

              <div>
                <span className={Styles.spanLeft}>
                  {loading ? <Skeleton /> : "Nomor Whatsapp"}
                </span>
                {loading ? (
                  <span className={Styles.spanRight}>
                    <Skeleton />
                  </span>
                ) : (
                  <div className={Styles.duplicate}>
                    <span>: {candidate?.phoneNumber || "-"}</span>

                    <Icon
                      icon={"duplicate"}
                      size={16}
                      color={"#1571DE"}
                      className={Styles.icon}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigator.clipboard
                          .writeText(candidate?.phoneNumber)
                          .then(() => {
                            setSuccess("Link berhasil disalin");
                          })
                          .catch((error) => {
                            // Tangani error jika copy ke clipboard gagal
                            console.error(
                              "Gagal menyalin ke clipboard:",
                              error
                            );
                          });
                      }}
                    />
                  </div>
                )}
              </div>

              <div>
                <span className={Styles.spanLeft}>
                  {loading ? <Skeleton /> : "Email"}
                </span>

                {loading ? (
                  <span className={Styles.spanRight}>
                    <Skeleton />
                  </span>
                ) : (
                  <div className={Styles.duplicate}>
                    <span>: {candidate?.email || "-"}</span>

                    <Icon
                      icon={"duplicate"}
                      size={16}
                      color={"#1571DE"}
                      className={Styles.icon}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigator.clipboard
                          .writeText(candidate?.email)
                          .then(() => {
                            setSuccess("Link berhasil disalin");
                          })
                          .catch((error) => {
                            // Tangani error jika copy ke clipboard gagal
                            console.error(
                              "Gagal menyalin ke clipboard:",
                              error
                            );
                          });
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {loading && (
          <>
            <div className={`${Styles.box} ${Styles.custom}`}>
              <div className={Styles.listExperiencesBox}>
                <div>
                  <div className={Styles.descExperience}>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                  </div>
                </div>
              </div>
            </div>

            <div className={`${Styles.box} ${Styles.custom}`}>
              <div className={Styles.listExperiencesBox}>
                <div>
                  <div className={Styles.descExperience}>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                  </div>
                </div>
              </div>
            </div>

            <div className={`${Styles.box} ${Styles.custom}`}>
              <div className={Styles.listExperiencesBox}>
                <div>
                  <div className={Styles.descExperience}>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {candidate?.workExperience?.length > 0 && !loading && (
          <div className={`${Styles.box} ${Styles.custom}`}>
            <div className={Styles.boxHeader}>
              <span className={Styles.H1Header}>Pengalaman Kerja</span>
              <span className={Styles.durationSpan}>
                <span>
                  {candidate?.totalWorkExperience?.years || 0} Tahun{" "}
                  {candidate?.totalWorkExperience?.months || 0} Bulan
                </span>{" "}
                Pengalaman Kerja
              </span>
            </div>

            <div className={Styles.listExperiencesBox}>
              {candidate?.workExperience?.map((el, idx) => {
                return (
                  <div key={idx}>
                    <div className={Styles.lineBlue}></div>
                    <div className={Styles.descExperience}>
                      <span className={Styles.titleExp}>
                        {el?.jobTitle || "-"}
                      </span>

                      <div className={Styles.otherInfo}>
                        <div className={Styles.info}>
                          <div>
                            <Icon
                              icon={"building"}
                              size={16}
                              color={"#0A0A0A"}
                            />
                          </div>
                          <span>{el?.companyName || "-"}</span>
                        </div>

                        <div className={Styles.bullet}></div>

                        <div className={Styles.info}>
                          <div>
                            <Icon
                              icon={"calender-outline"}
                              size={16}
                              color={"#0A0A0A"}
                            />
                          </div>
                          <span>
                            {el?.startMonth || "-"} {el?.startYear || "-"} -{" "}
                            {el?.isEmployed
                              ? "saat ini"
                              : `${el?.endMonth || "-"} ${el?.endYear || "-"}`}
                          </span>
                        </div>
                      </div>

                      <span className={Styles.descSpan}>
                        {el?.description || "-"}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {candidate?.skills?.length > 0 && !loading && (
          <div className={`${Styles.box} ${Styles.custom}`}>
            <div className={Styles.boxHeader}>
              <span className={Styles.H1Header}>Keterampilan</span>
            </div>

            <div className={Styles.skillsBox}>
              {candidate?.skills?.map((el, idx) => {
                return <div key={idx}>{el?.skill || "-"}</div>;
              })}
            </div>
          </div>
        )}

        {candidate?.applicantResponse?.length > 0 && !loading && (
          <div className={`${Styles.box} ${Styles.custom}`}>
            <div className={Styles.boxHeader}>
              <span className={Styles.H1Header}>
                Jawaban Pertanyaan Tambahan
              </span>
            </div>

            <div className={Styles.listExperiencesBox}>
              {candidate?.applicantResponse?.map((el, idx) => {
                return (
                  <div key={idx}>
                    <div className={Styles.lineBlue}></div>
                    <div className={Styles.descExperience}>
                      <span className={Styles.titleExp}>
                        {el?.question || "-"}
                      </span>

                      <span className={Styles.descSpan}>
                        {el?.answer || "-"}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {!loading &&
        (candidate?.videoProfile ||
          candidate?.documents?.filter(
            (el) => el?.label?.toLowerCase() !== "video"
          )?.length > 0) ? (
          <div className={`${Styles.box} ${Styles.custom}`}>
            {candidate?.videoProfile && (
              <div className={Styles.documentBox}>
                <span>Video Perkenalan Diri</span>
                <div
                  onClick={() => {
                    window.open(candidate?.videoProfile);
                  }}
                >
                  <div>
                    <div className={Styles.icon}>
                      <Icon icon={"video"} size={20} color={"#1571DE"} />
                    </div>
                    <span>{candidate?.videoProfile || "-"}</span>
                  </div>

                  <div>
                    <Icon icon={"download"} size={20} color={"#1571DE"} />
                  </div>
                </div>
              </div>
            )}

            {candidate?.documents?.filter(
              (el) => el?.label?.toLowerCase() !== "video"
            )?.length > 0 && (
              <div className={Styles.documentBox}>
                <span>Dokumen</span>

                {candidate?.documents
                  ?.filter((el) => el?.label?.toLowerCase() !== "video")
                  ?.map((el, idx) => {
                    return (
                      <div
                        key={idx}
                        onClick={() => {
                          window.open(fileBaseUrl + el?.url);
                        }}
                      >
                        <div>
                          <div className={Styles.icon}>
                            <Icon icon={"file"} size={20} color={"#1571DE"} />
                          </div>
                          <span>{el?.label || "-"}</span>
                        </div>

                        <div>
                          <Icon icon={"download"} size={20} color={"#1571DE"} />
                        </div>
                      </div>
                    );
                  })}
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
}
